import Cookies from 'js-cookie';

const mutations = {
  CREATE_SESSION(state, data) {
    state.sessionId = data.sessionId;
  },
  FLAGS_DATA(state, data) {
    localStorage.setItem('flagsData', JSON.stringify(data));
    state.flagsData = data;
  },
  SAVE_TOKEN(state, data) {
    state.token = `${data.tokenType} ${data.accessToken}`;
    localStorage.setItem('token', state.token);
    Cookies.set('authToken', state.token, { expires: 1, path: '/', secure: true, domain: '.epaylater.in' });
  },
  SAVE_PHONE(state, data) {
    state.phone = data;
    localStorage.setItem('phone', data);
    Cookies.set("mobileNo", data, { expires: 1, path: '/', secure: true, domain: '.epaylater.in' });
  },
  CLEAR_SESSION() {
    const url = new URL(window.location);
    const urlParams = localStorage.getItem("newUrl");
    const marketplaceName = localStorage.getItem('referralMarketplaceMcode');
    const callbackUrl = localStorage.getItem('referralCallbackUrl');
    if (marketplaceName) {
      url.searchParams.set('marketplaceName', marketplaceName);
    }
    if (callbackUrl) {
      url.searchParams.set('callbackUrl', callbackUrl);
    }
    localStorage.clear();
    if (urlParams) {
      window.location = urlParams;
    } else {
      if (callbackUrl !== null) {
        window.location = callbackUrl;
      } else {
        window.location = url;
      }
    return;
    }
      // localhost
      Cookies.remove('mobileNo');
      Cookies.remove('authToken');
      // serverSite
      Cookies.remove('mobileNo', { path: '/', domain: '.epaylater.in' });
      Cookies.remove('authToken', { path: '/', domain: '.epaylater.in' });
  },
  SAVE_MARKETPLACE_INFO(state, data) {
    localStorage.setItem('marketplaceInfo', JSON.stringify(data));
    state.marketplaceInfo = data;
  }
};
export default mutations;
